import { Box, Typography } from '@mui/material'
import { Constants } from '../constants'

const DominoPrizeCard = ({ item }) => {
    return (
        <Box
            sx={{
                padding: "0.8rem",
                border: "1px solid #DC143C",
                borderRadius: "1rem",
                position: "relative",
                marginTop:item?.marginTop
            }}
        >

            <Box
                component={"img"}
                src={item?.prizeLogo}
                sx={{
                    width: "50px",
                    position: "absolute",
                    top: "-20px",
                    right: "-10px"
                }}
            />
            <Box
                sx={{
                    backgroundImage: `linear-gradient(179.92deg, rgba(0, 0, 0, 0) 52.8%, #000000 94.77%), url(${item?.prizeImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'top',
                    backgroundRepeat: 'no-repeat',
                    height: "350px",
                    display: 'flex',
                    alignItems: "flex-end",
                    padding: "1rem 1rem",
                    borderRadius: "1rem"

                }}
            >
                <Typography variant='body2' color='primary.main'>
                    {item?.content}
                </Typography>
            </Box>
        </Box>
    )
}

export default DominoPrizeCard